<template>
	<div class="agri-page">
		<DetailPage v-if="detail" :detail="detail" @back="detail = null" />
		<!-- 首页含 echarts 图表，用 v-show 而非 v-if 隐藏，避免返回时 DOM 被销毁导致图表不重绘 -->
		<div v-show="!detail" class="agri-wrap flexCol alit">
			<!-- 第一行：火锅产品批发价格指数树 + 新闻资讯 -->
			<div class="row1 flex justc">
				<!-- 左：指数树 -->
				<div class="tree-col">
					<div class="flex justb alit">
						<div class="left-top-title flex alit">
							<img :src="icons.shujutongji" class="h-icon" alt="" />
							<div>农产品批发价格指数</div>
						</div>
					</div>
					<div class="left-top-date">{{ dateText }}</div>
					<div class="left-box">
						<!-- 末端产品子项 -->
						<div v-for="(item, index) in topLeftData" :key="index">
							<div class="line4-box flex alit" :style="{ left: item.left + 25 + 'px', top: item.top + 10 + 'px' }">
								<div>
									<div class="box-title">{{ item.title }}价格指数</div>
									<div class="flex alit" style="margin-top: 10px;">
										<a class="num">{{ item.num }}</a>
										<div class="increase flex alit">
											<img :src="icons.upArrow" alt="" class="img2" />
											<a>{{ item.zs }}</a>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="line0"></div>
						<div class="box1">{{ rootIndex.name }}</div>
						<div class="box2 flex alit">
							<a class="num">{{ rootIndex.num }}</a>
							<img :src="icons.upBig" alt="" class="img1" />
							<a class="icon-right-text">{{ rootIndex.zs }}</a>
						</div>
						<div class="line1"></div>
						<div class="box3">{{ rawIndex.num }}</div>
						<div class="box3-text">
							<a>{{ rawIndex.name }}</a>
							<div class="flex alit">
								<img :src="icons.upBig" alt="" class="img1" />
								<a class="icon-right-text">{{ rawIndex.zs }}</a>
							</div>
						</div>
						<div class="box4">{{ meatIndex.num }}</div>
						<div class="box4-text">
							<a>{{ meatIndex.name }}</a>
							<div class="flex alit">
								<img :src="icons.upBig" alt="" class="img1" />
								<a class="icon-right-text">{{ meatIndex.zs }}</a>
							</div>
						</div>
						<div class="line2"></div>
						<div class="line3"></div>
						<div class="line4"></div>
						<div class="line5"></div>
						<div class="line6"></div>
						<div class="line7"></div>
						<div class="line8"></div>
						<div class="line9"></div>
						<div class="line10"></div>
						<div class="line11"></div>
						<div class="line12"></div>
						<div class="line13"></div>
						<div class="line14"></div>
						<div class="line15"></div>
						<div class="line16"></div>
						<div class="line17"></div>
						<div class="line18"></div>
						<div class="line19"></div>
					</div>
				</div>

				<!-- 右：新闻资讯 -->
				<div class="news-col">
					<div class="flex justb alit">
						<div class="zx flex alit justc">
							<img :src="icons.news" class="h-icon" alt="" />
							<div>新闻资讯</div>
						</div>
						<div class="more" @click="goMore()">更多&gt;</div>
					</div>
					<div v-if="zxList.length > 0">
						<div v-for="(item, index) in zxList" :key="index" class="zx-list flex alit" @click="goInfo(item)">
							<div class="flex alit">
								<div class="dian"></div>
								<div class="zx-title">{{ item.title }}</div>
							</div>
							<div class="zx-time">{{ item.date }}</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 第二行：涨跌幅排名 + 分析报告 -->
			<div class="row2 flex">
				<div>
					<div class="zx flex alit">
						<img :src="icons.news" class="h-icon" alt="" />
						<div>火锅产品涨跌幅排名</div>
					</div>
					<div class="time">日期：{{ dateText }}</div>
					<div class="flex">
						<div ref="rankUp" style="width: 350px; height: 430px;"></div>
						<div ref="rankDown" style="width: 350px; height: 430px;"></div>
					</div>
				</div>
				<div class="report-col">
					<div class="zx flex alit">
						<img :src="icons.news" class="h-icon" alt="" />
						<div>分析报告</div>
					</div>
					<div class="flex" style="width: 480px;">
						<div :class="bg == 1 ? 'bg-click' : 'bg-default'" style="border-radius: 13px 0 0 13px;"
							@click="getBg('日度报告', 1)">日度报告</div>
						<div :class="bg == 2 ? 'bg-click' : 'bg-default'" style="border-left: none; border-right: none;"
							@click="getBg('周度报告', 2)">周度报告</div>
						<div :class="bg == 3 ? 'bg-click' : 'bg-default'" style="border-radius: 0 13px 13px 0;"
							@click="getBg('月度报告', 3)">月度报告</div>
					</div>
					<div style="margin-top: 20px;">
						<div v-for="item in bgList" :key="item.id" class="bg-list flex alit justb" @click="goInfo(item)">
							<div class="flex alit">
								<div class="dian"></div>
								<div class="zx-title">{{ item.title }}</div>
							</div>
							<div class="zx-time">{{ item.date }}</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 第三行：全国火锅产业地图 -->
			<div class="map-section">
				<div class="hangqing">
					<div class="hen"></div>
					全国火锅产业地图展示
					<div class="hen"></div>
				</div>
				<div ref="chinaMap" class="china-map"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import * as echarts from 'echarts'
	import DetailPage from './DetailPage.vue'

	const OBS = 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/hg/webIcon/'

	// 指数树 6 个末端叶子的固定版式坐标（接口按顺序回填数值/名称）
	const TREE_LEAF_POS = [
		{ left: 230, top: 50 }, { left: 420, top: 50 }, { left: 270, top: 140 },
		{ left: 456, top: 140 }, { left: 230, top: 230 }, { left: 308, top: 300 },
	]

	export default {
		name: 'AgriIndex200',
		components: { DetailPage },
		data() {
			return {
				icons: {
					shujutongji: OBS + 'shujutongji.png',
					news: OBS + '%E6%96%B0%E9%97%BB%E8%B5%84%E8%AE%AF.png',
					upBig: OBS + 'hometop.263486b2.gif',
					upArrow: OBS + 'hometopback.98de06f3.gif',
				},
				// 指数树：全部为假数据，接口就绪后替换
				dateText: '',
				rootIndex: { name: '火锅产品批发价格指数', num: '124.9', zs: '+0.4' },
				rawIndex: { name: '“原材料”产品批发价格指数', num: '33.5', zs: '+0.23' },
				meatIndex: { name: '“禽畜食材”产品批发价格指数', num: '45.4', zs: '+0.25' },
				topLeftData: [{
						left: 230, top: 50, title: '辣椒', num: '15.2', zs: '+0.82'
					}, {
						left: 420, top: 50, title: '花椒', num: '29.7', zs: '+0.36'
					}, {
						left: 270, top: 140, title: '大蒜', num: '10.48', zs: '+0.54'
					}, {
						left: 456, top: 140, title: '其他', num: '13.5', zs: '+0.12'
					}, {
						left: 230, top: 230, title: '鲜肉', num: '48.2', zs: '+0.34'
					}, {
						left: 308, top: 300, title: '其他', num: '43.8', zs: '+0.21'
					},
				],
				// 新闻资讯（假数据）
				zxList: [{
						id: 1, title: '火锅行业周度监测：底料原料成本环比小幅上行', date: '10-27'
					}, {
						id: 2, title: '重庆火锅协会发布第三季度产业运行报告', date: '10-24'
					}, {
						id: 3, title: '牛油、花椒等火锅食材批发价格走强', date: '10-21'
					}, {
						id: 4, title: '多家火锅品牌加速布局下沉市场', date: '10-18'
					}, {
						id: 5, title: '冷链升级保障火锅食材全国流通', date: '10-15'
					},
				],
				bg: 1,
				bgMap: {
					1: [{
							id: 11, title: '火锅产品批发价格指数日度分析（原材料）', date: '10-28'
						}, {
							id: 12, title: '火锅产品批发价格指数日度分析（禽畜食材）', date: '10-28'
						}, {
							id: 13, title: '辣椒日度行情简报', date: '10-27'
						},
					],
					2: [{
							id: 21, title: '火锅产品批发价格指数周度综述', date: '10-26'
						}, {
							id: 22, title: '花椒周度价格波动分析', date: '10-26'
						}, {
							id: 23, title: '牛油周度供需与价格走势', date: '10-19'
						},
					],
					3: [{
							id: 31, title: '火锅产业月度景气指数报告', date: '10-08'
						}, {
							id: 32, title: '火锅食材采购月度分析', date: '10-08'
						}, {
							id: 33, title: '全国火锅门店月度分布报告', date: '09-08'
						},
					],
				},
				bgList: [],
				// 当前选中展示的详情（首页新闻/报告共用 DetailPage）
				detail: null,
				// 涨跌幅排名（假数据）
				rankUpData: {
					item: ['牛肉', '鲜虾', '牛肉丸子', '毛肚', '卤牛肉', '辣椒', '牛油', '木耳', '花椒'],
					value: [8.7, 6.2, 3.4, 2.8, 2.2, 1.8, 1.4, 0.2, 1.2],
				},
				rankDownData: {
					item: ['猪肉', '猪肝', '猪肺', '酥肉', '猪排', '植物油', '耗儿鱼', '冬菇', '葱'],
					value: [2.7, 2.2, 1.4, 0.8, 1.2, 2.8, 1.4, 0.2, 1.2],
				},
				// 地图城市（假数据）
				mapCities: [{
						name: '重庆', value: [106.504962, 29.533155, 98]
					}, {
						name: '成都', value: [104.0665, 30.5723, 86]
					}, {
						name: '北京', value: [116.405285, 39.904989, 72]
					}, {
						name: '上海', value: [121.472644, 31.231706, 68]
					}, {
						name: '武汉', value: [114.30539, 30.59309, 55]
					}, {
						name: '长沙', value: [112.9388, 28.2282, 51]
					}, {
						name: '西安', value: [108.948024, 34.263011, 44]
					}, {
						name: '郑州', value: [113.665496, 34.757976, 40]
					}, {
						name: '广州', value: [113.2644, 23.1291, 47]
					}, {
						name: '昆明', value: [102.73, 25.04, 33]
					},
				],
			}
		},
		mounted() {
			this.dateText = this.getDate()
			this.getBg('日度报告', 1)
			this.$nextTick(() => {
				this.initRank('rankUp', this.rankUpData, '涨幅排名', ['#329794', '#00fffc'], '#f88a4d')
				this.initRank('rankDown', this.rankDownData, '跌幅排名', ['#ff9a9e', '#fad0c4'], '#329794')
				this.loadAll()
			})
		},
		beforeDestroy() {
			;[this._rankUp, this._rankDown, this._map].forEach(c => c && c.dispose())
		},
		methods: {
			getDate() {
				const da = new Date()
				let month = da.getMonth() + 1
				month = month < 10 ? '0' + month : month
				let day = da.getDate()
				day = day < 10 ? '0' + day : day
				return da.getFullYear() + '年' + month + '月' + day + '日'
			},
			loadAll() {
				this.loadIndexTree()
				this.loadRank()
				this.loadNews()
				this.loadReports()
				this.loadMap()
			},
			// 拉取某类快照：外层 data[0].data 是上游原始 JSON 文本，解析后交给对应 apply 方法
			fetchSource(type) {
				return this.$request2('/admin-api/governance/pfsc-source-data/list-by-type', { params: { type } }).then(res => {
					if (!res || res.code !== 0 || !Array.isArray(res.data) || !res.data.length) return null
					const item = res.data[0]
					let parsed = null
					try { parsed = JSON.parse(item.data) } catch (e) { parsed = null }
					return { parsed: parsed, dataDate: item.dataDate }
				}).catch(() => null)
			},
			signed(v) {
				const n = Number(v)
				if (isNaN(n)) return ''
				return (n > 0 ? '+' : '') + n
			},
			shortDate(s) {
				if (!s) return ''
				const m = String(s).match(/\d{4}-(\d{2})-(\d{2})/)
				return m ? m[1] + '-' + m[2] : String(s).slice(0, 10)
			},
			formatDateCN(s) {
				if (!s) return this.getDate()
				const m = String(s).match(/(\d{4})-(\d{2})-(\d{2})/)
				return m ? m[1] + '年' + m[2] + '月' + m[3] + '日' : String(s)
			},
			// type=2 价格指数树：parsed 为 [[根],[菜篮子,粮油],[6个末端]]
			loadIndexTree() {
				this.fetchSource(2).then(d => {
					if (!d || !Array.isArray(d.parsed)) return
					const g0 = d.parsed[0] || [], g1 = d.parsed[1] || [], g2 = d.parsed[2] || []
					const mk = it => it ? { name: it.indexName, num: it.indexValue, zs: this.signed(it.weightValue) } : null
					const r = mk(g0[0]); if (r) this.rootIndex = r
					const ra = mk(g1[0]); if (ra) this.rawIndex = ra
					const me = mk(g1[1]); if (me) this.meatIndex = me
					const leaves = g2.slice(0, 6)
					if (leaves.length) {
						this.topLeftData = leaves.map((it, i) => ({
							left: TREE_LEAF_POS[i].left, top: TREE_LEAF_POS[i].top,
							title: it.indexName, num: it.indexValue, zs: this.signed(it.weightValue)
						}))
					}
					const src = (g0[0] && g0[0].publishDate) || d.dataDate
					if (src) this.dateText = this.formatDateCN(src)
				})
			},
			// type=1 涨跌幅排名：names/priceHbs 同序，正数入涨幅、负数取绝对值入跌幅
			loadRank() {
				this.fetchSource(1).then(d => {
					if (!d || !d.parsed) return
					const names = d.parsed.names || [], hbs = d.parsed.priceHbs || []
					const items = names.map((n, i) => ({ name: n, hb: Number(hbs[i]) })).filter(p => p.name && !isNaN(p.hb))
					const up = items.filter(p => p.hb > 0).sort((a, b) => b.hb - a.hb)
					const down = items.filter(p => p.hb < 0).sort((a, b) => a.hb - b.hb)
					if (!up.length && !down.length) return
					this.rankUpData = { item: up.map(p => p.name), value: up.map(p => +p.hb.toFixed(2)) }
					this.rankDownData = { item: down.map(p => p.name), value: down.map(p => +Math.abs(p.hb).toFixed(2)) }
					this.$nextTick(() => {
						this.initRank('rankUp', this.rankUpData, '涨幅排名', ['#329794', '#00fffc'], '#f88a4d')
						this.initRank('rankDown', this.rankDownData, '跌幅排名', ['#ff9a9e', '#fad0c4'], '#329794')
					})
				})
			},
			// 新闻资讯：与 NewsInfo 同接口 item-page（category=3, period=0），首页只取第1页 10 条
			loadNews() {
				this.$request2('/admin-api/governance/pfsc-source-data/item-page', {
					params: { pageNo: 1, pageSize: 10, category: 3, period: 0 }
				}).then(res => {
					if (!res || res.code !== 0 || !res.data || !Array.isArray(res.data.list) || !res.data.list.length) return
					this.zxList = res.data.list.map(it => this.mapNewsRow(it))
				}).catch(() => {})
			},
			// 单行资讯：解析 item.data 原始 JSON，保留详情页需要的 title/source/dateText/text
			mapNewsRow(it) {
				let obj = {}
				try { obj = JSON.parse(it.data) || {} } catch (e) { obj = {} }
				const date = obj.publishDate || it.dataDate || ''
				const content = String(obj.contentstr || obj.content || '')
				return {
					id: it.id,
					title: obj.title || '',
					date: this.shortDate(date),
					dateText: date,
					source: obj.source || '',
					html: '',
					text: content,
				}
			},
			// 分析报告改用分页接口 item-page：category=2，period 1/2/3=日/周/月；首页各粒度只取一页(前3条)
			loadReports() {
				const periodMap = { 1: 1, 2: 2, 3: 3 } // bg 键 → period
				Object.keys(periodMap).forEach(k => {
					const bgKey = Number(k), period = periodMap[k]
					this.$request2('/admin-api/governance/pfsc-source-data/item-page', {
						params: { pageNo: 1, pageSize: 10, category: 2, period: period }
					}).then(res => {
						if (!res || res.code !== 0 || !res.data || !Array.isArray(res.data.list) || !res.data.list.length) return
						const list = res.data.list.slice(0, 20).map(it => this.mapReportRow(it))
						this.$set(this.bgMap, bgKey, list)
						if (this.bg === bgKey) this.bgList = list
					}).catch(() => {})
				})
			},
			// 单行报告：标题取 item.data 里的 remark（如“2026.10.30-农产品批发市场价格日报”），回退 counclsion/indexConclusion/dataDate
			mapReportRow(it) {
				let obj = null
				try { obj = JSON.parse(it.data) } catch (e) { obj = null }
				obj = obj || {}
				const title = obj.remark || obj.counclesion || obj.indexConclusion || it.dataDate || '分析报告'
				return {
					id: it.id, title: title, date: this.formatReportDate(it.dataDate || obj.daylyDate || ''),
					dateText: obj.daylyDate || it.dataDate || '', source: obj.source || '',
					html: obj.countent || '', text: obj.countentstr || obj.counclesion || obj.indexConclusion || '',
				}
			},
			// 报告日期格式化：日/月 YYYY-MM-DD→MM-DD；周度区间 20261016-20261022→10.16-10.22
			formatReportDate(s) {
				if (!s) return ''
				const str = String(s)
				const w = str.match(/\d{4}(\d{2})(\d{2})-\d{4}(\d{2})(\d{2})/)
				if (w) return w[1] + '.' + w[2] + '-' + w[3] + '.' + w[4]
				const m = str.match(/(\d{2})-(\d{2})\s*$/) || str.match(/\d{4}-(\d{2})-(\d{2})/)
				if (m) return m[1] + '-' + m[2]
				return str.slice(0, 10)
			},
			getBg(type, index) {
				this.bg = index
				this.bgList = this.bgMap[index] || []
			},
			goMore() {
				// 新闻资讯“更多”→通知父级 OriginCenter 切到新闻资讯子页
				this.$emit('nav', 'NewsInfo')
			},
			goInfo(item) {
				if (!item) return
				this.detail = {
					title: item.title,
					source: item.source || '',
					date: item.dateText || item.date || '',
					html: item.html || '',
					text: item.text || '',
				}
			},
			showToast(msg) {
				this.$message && this.$message.closeAll()
				this.$message && this.$message({ message: msg, duration: 1500 })
			},
			// 横向条形排名图（Vue2 重写自 hotPotIndex 的 leftChart/rightChart）
			initRank(refName, data, title, barColors, labelColor) {
				const el = this.$refs[refName]
				if (!el) return
				const prev = this['_' + refName]
				if (prev) prev.dispose()
				const chart = echarts.init(el)
				const pairs = data.item.map((n, i) => ({ name: n, value: data.value[i] })).sort((a, b) => b.value - a.value)
				chart.setOption({
					title: { text: title, left: 'center', textStyle: { fontSize: 14, color: '#333' } },
					backgroundColor: '#fff',
					tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }, textStyle: { fontSize: 12 } },
					grid: { left: '4%', right: '16%', top: '10%', bottom: '2%', containLabel: true },
					xAxis: { show: true, boundaryGap: [0, 0.2], splitLine: { lineStyle: { type: 'dashed' } } },
					yAxis: {
						type: 'category',
						inverse: true,
						axisLine: { show: false },
						axisTick: { show: false },
						axisLabel: { show: true, margin: 12, color: '#333', fontSize: 12 },
						data: pairs.map(p => p.name),
					},
					series: [{
						type: 'bar',
						barCategoryGap: '50%',
						barWidth: 16,
						label: { show: true, position: 'right', formatter: p => Number(p.value).toFixed(2), color: labelColor },
						itemStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
									offset: 0, color: barColors[0]
								}, {
									offset: 1, color: barColors[1]
								}], false),
							borderRadius: [0, 50, 50, 0],
						},
						data: pairs.map(p => p.value),
					}],
				})
				this['_' + refName] = chart
			},
			// type=7 市场地图：数组，每项 longitude/latitude 为字符串、count 为热度、marketName 为名称
			loadMap() {
				this.fetchSource(7).then(d => {
					if (d && Array.isArray(d.parsed)) {
						const cities = d.parsed.map(it => {
							const lon = Number(it.longitude), lat = Number(it.latitude)
							if (!lon || !lat) return null
							return { name: it.marketName || it.label || it.enterpriseName || '批发市场', value: [lon, lat, Number(it.count) || 0] }
						}).filter(Boolean)
						if (cities.length) this.mapCities = cities
					}
					this.initMap()
				})
			},
			// 中国地图：geoJSON 走 brain 已用的 OBS 主机；点数多时隐藏标签，仅悬停看详情
			initMap() {
				const el = this.$refs.chinaMap
				if (!el) return
				if (this._map) { this._map.dispose(); this._map = null }
				const chart = echarts.init(el)
				this._map = chart
				const showLabel = this.mapCities.length <= 15
				fetch('https://qgst.obs.cn-southwest-2.myhuaweicloud.com/hotpot/brain/mapJss/100000.geoJson')
					.then(r => r.json())
					.then(geo => {
						if (this._map !== chart) return
						echarts.registerMap('china', geo)
						chart.setOption({
							backgroundColor: 'transparent',
							tooltip: {
								trigger: 'item',
								formatter: e => (e.data && e.data.name ? e.data.name + '：' + e.data.value[2] : ''),
							},
							geo: [{
								type: 'map', map: 'china', layoutCenter: ['50%', '52%'], layoutSize: '105%',
								roam: false, silent: true,
								itemStyle: { areaColor: '#eaf3ff', borderColor: '#9ec7f0', borderWidth: 1 },
								emphasis: { disabled: true },
							}],
							series: [{
								type: 'effectScatter', coordinateSystem: 'geo', geoIndex: 0, zlevel: 2,
								symbolSize: v => Math.max(6, Math.min(18, v[2] / 6)),
								showEffectOn: 'render',
								rippleEffect: { brushType: 'stroke', scale: 3 },
								itemStyle: { color: '#e28350' },
								label: { show: showLabel, formatter: '{b}', position: 'right', color: '#c50b02', fontSize: 11 },
								data: this.mapCities,
							}],
						})
					})
					.catch(() => {
						if (this._map !== chart) return
						el.innerHTML = '<div style="display:flex;height:100%;align-items:center;justify-content:center;color:#999;">地图数据加载失败</div>'
					})
			},
		},
	}
</script>

<style scoped lang="scss">
	.agri-page {
		flex: 1;
		min-height: 0;
		overflow: auto;
		background: #f5f6f8;
		box-sizing: border-box;
	}

	.agri-wrap {
		max-width: 1300px;
		margin: 0 auto;
		padding: 20px 10px 40px;
	}

	.h-icon {
		width: 20px;
		height: 20px;
		margin-right: 5px;
	}

	/* ===== 第一行 ===== */
	.row1 {
		height: 500px;
		margin-top: 20px;
		align-items: flex-start;
	}

	.tree-col {
		width: 670px;
		border-right: 1px solid #d0d0d0;
	}

	.news-col {
		margin-left: 40px;
		width: 580px;
	}

	.left-top-title {
		border-bottom: 2px solid #d0d0d0;
		font-size: 17px;
		color: #c50b02;
		font-weight: 600;
		margin-top: 10px;
		margin-bottom: 20px;
		padding-bottom: 4px;
	}

	.left-top-date {
		color: #333;
		font-size: 20px;
		padding-left: 27px;
		font-weight: 700;
	}

	/* 指数树：绝对定位手绘连线 */
	.left-box {
		position: relative;
		margin-top: 40px;
		height: 400px;

		.box-title {
			font-size: 14px;
			letter-spacing: 1px;
			color: #333;
			white-space: nowrap;
		}

		.increase {
			display: inline-block;
			min-width: 70px;
			height: 18px;
			background-color: #ed6b48;
			border-radius: 3px;
			margin-left: 5px;
			line-height: 18px;
			color: #fff;
			font-size: 13px;
		}

		.num {
			font-size: 18px;
			letter-spacing: 2px;
			color: #333;
			display: inline-block;
			padding-left: 10px;
		}

		.img1 {
			width: 15px;
			height: 14px;
			margin-left: 10px;
		}

		.img2 {
			width: 10px;
			height: 10px;
			margin: 0 4px 0 10px;
		}

		.icon-right-text {
			font-size: 14px;
			display: inline-block;
			color: #ed6b48;
			margin-left: 5px;
		}

		.line4-box {
			position: absolute;
		}

		.line0 {
			position: absolute;
			border: 2px solid #e28350;
			border-right: none;
			height: 210px;
			width: 30px;
			left: 0;
		}

		.line1 {
			position: absolute;
			height: 169px;
			width: 30px;
			border-radius: 2px;
			border: 2px solid #e28350;
			border-right: none;
			top: 120px;
			left: 30px;
		}

		.line2 {
			width: 430px;
			height: 1px;
			background-color: #0dad3e;
			position: absolute;
			top: 120px;
			left: 193px;
		}

		.line3 {
			width: 6px;
			height: 6px;
			background-color: #0dad3e;
			border-radius: 50%;
			position: absolute;
			top: 50px;
			left: 217px;
		}

		.line4 {
			width: 1px;
			height: 70px;
			background-color: #0dad3e;
			position: absolute;
			top: 50px;
			left: 219.5px;
		}

		.line5 {
			width: 1px;
			height: 70px;
			background-color: #0dad3e;
			position: absolute;
			top: 50px;
			left: 410px;
		}

		.line6 {
			width: 6px;
			height: 6px;
			background-color: #0dad3e;
			border-radius: 50%;
			position: absolute;
			top: 50px;
			left: 408px;
		}

		.line7 {
			width: 6px;
			height: 6px;
			background-color: #0dad3e;
			border-radius: 50%;
			position: absolute;
			top: 117px;
			left: 623px;
		}

		.line8 {
			width: 1px;
			height: 70px;
			background-color: #0dad3e;
			position: absolute;
			top: 120px;
			left: 260px;
		}

		.line9 {
			width: 6px;
			height: 6px;
			background-color: #0dad3e;
			border-radius: 50%;
			position: absolute;
			top: 190px;
			left: 257px;
		}

		.line10 {
			width: 1px;
			height: 70px;
			background-color: #0dad3e;
			position: absolute;
			top: 120px;
			left: 445.8px;
		}

		.line11 {
			width: 6px;
			height: 6px;
			background-color: #0dad3e;
			border-radius: 50%;
			position: absolute;
			top: 190px;
			left: 443px;
		}

		.line12 {
			width: 281px;
			height: 1px;
			background-color: #e8ab18;
			position: absolute;
			top: 290px;
			left: 193px;
		}

		.line13 {
			width: 6px;
			height: 6px;
			background-color: #e8ab18;
			border-radius: 50%;
			position: absolute;
			top: 287px;
			left: 474px;
		}

		.line14 {
			width: 1px;
			height: 70px;
			background-color: #e8ab18;
			position: absolute;
			top: 220px;
			left: 220px;
		}

		.line15 {
			width: 6px;
			height: 6px;
			background-color: #e8ab18;
			border-radius: 50%;
			position: absolute;
			top: 220px;
			left: 218px;
		}

		.line16 {
			width: 1px;
			height: 70px;
			background-color: #e8ab18;
			position: absolute;
			top: 290px;
			left: 298px;
		}

		.line17 {
			width: 6px;
			height: 6px;
			background-color: #e8ab18;
			border-radius: 50%;
			position: absolute;
			top: 360px;
			left: 296px;
		}

		.line18 {
			width: 1px;
			height: 70px;
			background-color: #e8ab18;
			position: absolute;
			top: 220px;
			left: 410px;
		}

		.line19 {
			width: 6px;
			height: 6px;
			background-color: #e8ab18;
			border-radius: 50%;
			position: absolute;
			top: 220px;
			left: 408px;
		}

		.box1 {
			width: 246px;
			height: 34px;
			line-height: 34px;
			background-color: #e28350;
			position: absolute;
			top: -16px;
			left: 30px;
			text-align: center;
			font-size: 18px;
			letter-spacing: 2px;
			color: #fff;
			display: inline-block;
		}

		.box2 {
			width: 219px;
			height: 34px;
			border: 2px solid #e28350;
			position: absolute;
			top: -16px;
			left: 275px;
			line-height: 34px;
		}

		.box3 {
			width: 131px;
			height: 30px;
			border: 2px solid #0dad3e;
			position: absolute;
			top: 103px;
			left: 60px;
			text-align: center;
			line-height: 30px;
			font-size: 16px;
			letter-spacing: 1px;
			color: #0dad3e;
		}

		.box3-text {
			font-weight: 700;
			font-size: 13px;
			line-height: 20px;
			letter-spacing: 0;
			color: #0dad3e;
			position: absolute;
			top: 55px;
			left: 62px;
			width: 185px;

			> a {
				display: block;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}
		}

		.box4 {
			width: 128px;
			height: 30px;
			border: 2px solid #e8ab18;
			position: absolute;
			top: 273px;
			left: 60px;
			text-align: center;
			line-height: 30px;
			font-size: 16px;
			letter-spacing: 1px;
			color: #ed6b48;
		}

		.box4-text {
			font-weight: 700;
			font-size: 13px;
			line-height: 20px;
			letter-spacing: 0;
			color: #e1a412;
			position: absolute;
			top: 225px;
			left: 55px;
			width: 190px;

			> a {
				display: block;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}
		}
	}

	/* ===== 通用小标题 / 列表 ===== */
	.zx {
		line-height: 35px;
		border-bottom: 2px solid #d0d0d0;
		font-size: 17px;
		color: #c50b02;
		font-weight: 600;
		margin-bottom: 10px;
	}

	.more {
		color: rgba(102, 102, 102, 1);
		font-size: 15px;
		cursor: pointer;
	}

	.dian {
		width: 4px;
		height: 4px;
		border-radius: 50%;
		background: #80c269;
		margin-right: 6px;
		flex: 0 0 auto;
	}

	.zx-list {
		letter-spacing: 1px;
		height: 36px;
		background-color: #fcfcfc;
		border: 1px solid #eee;
		cursor: pointer;
		margin-bottom: 5px;
		padding: 0 10px;
		box-sizing: border-box;

		.zx-time {
			line-height: 36px;
			font-size: 14px;
			margin-left: auto;
		}

		.zx-title {
			width: 400px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			font-size: 16px;
			height: 36px;
			line-height: 36px;
			letter-spacing: 1px;
			color: #333;
		}
	}

	.zx-list:hover {
		border: 1px solid #80c269;
		background-color: #f0fff8;

		.zx-title {
			color: #6ab823;
		}
	}

	/* ===== 第二行 ===== */
	.row2 {
		min-width: 1300px;
		margin-top: 30px;
	}

	.report-col {
		margin-left: 20px;
		border-left: 1px solid #d0d0d0;
		padding-left: 20px;
	}

	.time {
		font-size: 15px;
		color: #3a3a3a;
		margin-bottom: 6px;
	}

	.bg-default {
		background-color: #fff;
		color: #0aa385;
		text-align: center;
		border: 1px solid #0aa385;
		cursor: pointer;
		font-size: 18px;
		width: 33%;
		padding: 7px 0;
	}

	.bg-click {
		background-color: #0aa385;
		color: #fff;
		text-align: center;
		border: 1px solid #0aa385;
		cursor: pointer;
		font-size: 18px;
		width: 33%;
		padding: 7px 0;
	}

	.bg-list {
		background-color: #fcfcfc;
		border: 1px solid #eee;
		width: 550px;
		padding: 0 5px;
		margin-bottom: 4px;
		cursor: pointer;
		box-sizing: border-box;

		.zx-title {
			width: 400px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			font-size: 16px;
			height: 36px;
			line-height: 36px;
			letter-spacing: 1px;
			color: #333;
		}

		.zx-time {
			font-size: 14px;
			margin-right: 6px;
		}
	}

	/* ===== 第三行 地图 ===== */
	.map-section {
		margin-top: 30px;
	}

	.hangqing {
		font-size: 17px;
		color: #c50b02;
		font-weight: 600;
		margin-bottom: 10px;
		margin-top: 20px;
		text-align: center;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.hen {
			width: 530px;
			height: 1px;
			background-color: #c50b02;
		}
	}

	.china-map {
		width: 1300px;
		height: 520px;
	}
</style>
